(function() {
  function updateHeaderHeight() {
    const headerSection = document.querySelector('.section-header');
    // While the header is pinned compact, its own (and the announcement bar's)
    // offsetHeight reflects the collapsed size, not the real reserved size.
    // header.liquid's own resize observer skips updates in that state for the
    // same reason; this one has to match, or it stomps --header-height down to
    // the collapsed total, shrinking the live-bound compact spacer out from
    // under the page and shifting everything below it up.
    if (headerSection && headerSection.classList.contains('ec-header-compact')) return;

    const announcementSection = document.querySelector('.announcement-bar-section');
    let totalHeight = 0;
    if (announcementSection) totalHeight += announcementSection.offsetHeight;
    if (headerSection) totalHeight += headerSection.offsetHeight;
    document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
  }

  function initEcMobileSearch() {
    const headerResizeObserver = new ResizeObserver(function() {
      updateHeaderHeight();
    });
    const announcementSection = document.querySelector('.announcement-bar-section');
    const headerSection = document.querySelector('.section-header');
    if (announcementSection) headerResizeObserver.observe(announcementSection);
    if (headerSection) headerResizeObserver.observe(headerSection);

    document.querySelectorAll('[data-ec-mobile-search]').forEach((wrapper) => {
      if (wrapper.dataset.ecMobileSearchInit) return;
      const trigger = wrapper.querySelector('[data-ec-mobile-search-trigger]');
      const panel = wrapper.querySelector('[data-ec-mobile-search-panel]');
      const overlay = wrapper.querySelector('[data-ec-mobile-search-overlay]');
      if (!trigger || !panel) return;

      function setOverlayAndPanelPosition() {
        const announcement = document.querySelector('.announcement-bar-section');
        const headerSection = document.querySelector('.section-header');
        let bottom = 0;
        if (announcement) bottom = Math.max(bottom, announcement.getBoundingClientRect().bottom);
        if (headerSection) bottom = Math.max(bottom, headerSection.getBoundingClientRect().bottom);
        if (bottom > 0) {
          panel.style.top = bottom + 'px';
          if (overlay) overlay.style.top = bottom + 'px';
        } else {
          panel.style.top = '';
          if (overlay) overlay.style.top = '';
        }
      }

      function open() {
        updateHeaderHeight();
        if (overlay) {
          overlay.removeAttribute('hidden');
          overlay.setAttribute('aria-hidden', 'false');
        }
        requestAnimationFrame(setOverlayAndPanelPosition);
        panel.removeAttribute('hidden');
        panel.setAttribute('data-ec-mobile-search-open', '');
        trigger.setAttribute('aria-expanded', 'true');
        const input = panel.querySelector('.ec-search-input');
        if (input) {
          setTimeout(function() { input.focus(); }, 50);
        }
      }

      function close() {
        if (overlay) {
          overlay.setAttribute('hidden', '');
          overlay.setAttribute('aria-hidden', 'true');
          overlay.style.top = '';
        }
        panel.setAttribute('hidden', '');
        panel.removeAttribute('data-ec-mobile-search-open');
        panel.style.top = '';
        trigger.setAttribute('aria-expanded', 'false');
      }

      function isOpen() {
        return panel.hasAttribute('data-ec-mobile-search-open');
      }

      trigger.addEventListener('click', function() {
        if (isOpen()) close();
        else open();
      });

      document.addEventListener('click', function(e) {
        if (!isOpen()) return;
        if (e.target === overlay || (overlay && overlay.contains(e.target))) {
          close();
          return;
        }
        if (panel.contains(e.target) || trigger.contains(e.target)) return;
        close();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape' || !isOpen()) return;
        close();
        trigger.focus();
      });

      function updatePanelPosition() {
        if (!isOpen()) return;
        setOverlayAndPanelPosition();
      }

      window.addEventListener('scroll', updatePanelPosition, { passive: true });
      window.addEventListener('resize', updatePanelPosition);

      wrapper.dataset.ecMobileSearchInit = 'true';
    });
  }

  function initEcPopularSearches() {
    document.querySelectorAll('.ec-search').forEach((container) => {
      if (container.dataset.ecPopularInit) return;
      const blocks = [
        container.querySelector('.ec-search-desktop'),
        container.querySelector('.ec-search-mobile-panel')
      ].filter(Boolean);

      blocks.forEach((block) => {
        const popularSearches = block.querySelector('.ec-popular-searches');
        const searchInput = block.querySelector('.ec-search-input');
        if (!popularSearches || !searchInput) return;

        function show() {
          popularSearches.removeAttribute('hidden');
        }

        function hide() {
          popularSearches.setAttribute('hidden', '');
        }

        const predictiveSearch = block.querySelector('predictive-search') || block.querySelector('ec-predictive-search');

        // With predictive search, keep showing Popular Searches until a real
        // product match opens the results dropdown; without it (plain search
        // form, no live preview) fall back to hiding as soon as text is typed.
        function syncVisibility() {
          if (predictiveSearch) {
            if (predictiveSearch.getAttribute('open') === 'true') hide();
            else show();
          } else if (searchInput.value.trim()) {
            hide();
          } else {
            show();
          }
        }

        searchInput.addEventListener('focus', syncVisibility);
        searchInput.addEventListener('input', syncVisibility);

        block.addEventListener('focusout', function() {
          setTimeout(function() {
            if (!block.contains(document.activeElement)) hide();
          });
        });

        if (predictiveSearch) {
          const observer = new MutationObserver(syncVisibility);
          observer.observe(predictiveSearch, { attributes: true, attributeFilter: ['open'] });
        }

        popularSearches.querySelectorAll('.ec-popular-searches-item').forEach(function(btn) {
          btn.addEventListener('click', function() {
            const term = btn.getAttribute('data-ec-search-term');
            if (term) {
              searchInput.value = term;
              searchInput.focus();
              searchInput.dispatchEvent(new Event('input', { bubbles: true }));
              hide();
            }
          });
        });
      });

      container.dataset.ecPopularInit = 'true';
    });
  }

  function init() {
    updateHeaderHeight();
    initEcMobileSearch();
    initEcPopularSearches();
    window.addEventListener('resize', updateHeaderHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
